var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadHero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "375px",
    height: "354px",
    viewBox: "0 0 375 354",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.1785156%",
    y1: "38.3638139%",
    x2: "52.1785156%",
    y2: "97.7816218%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2EEFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.1785156%",
    y1: "38.3638139%",
    x2: "52.1785156%",
    y2: "97.7816218%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2EEFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1ECFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 375,
    height: 354
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-24.3%",
    y: "-22.1%",
    width: "148.7%",
    height: "144.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 31,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-24.3%",
    y: "-22.1%",
    width: "148.7%",
    height: "144.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 31,
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u3010\\u805A\\u878D\\u6613\\u3011\\u6CE8\\u518C\\u5BFC\\u4E0B\\u8F7D_\\u7D2B\\u8272",
    transform: "translate(0.000000, -88.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-11",
    transform: "translate(0.000000, -12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-9",
    transform: "translate(0.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u8499\\u7248",
    fill: "url(#linearGradient-1)",
    x: 0,
    y: 0,
    width: 375,
    height: 354
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6\\u7ED3\\u5408"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\u8499\\u7248",
    fill: "url(#linearGradient-2)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,-97 C239.378739,-97 294,-42.3787395 294,25 C294,45.9395209 288.724672,65.646923 279.430539,82.8656845 C289.198326,80.3410142 299.442558,79 310,79 C377.378739,79 432,133.621261 432,201 C432,268.378739 377.378739,323 310,323 C242.621261,323 188,268.378739 188,201 C188,180.060479 193.275328,160.353077 202.569461,143.134315 C192.801674,145.658986 182.557442,147 172,147 C104.621261,147 50,92.3787395 50,25 C50,-42.3787395 104.621261,-97 172,-97 Z",
    fill: "#F7F4FF",
    filter: "url(#filter-5)",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,-135 C407.378739,-135 462,-80.3787395 462,-13 C462,7.93952089 456.724672,27.646923 447.430539,44.8656845 C457.198326,42.3410142 467.442558,41 478,41 C545.378739,41 600,95.6212605 600,163 C600,230.378739 545.378739,285 478,285 C410.621261,285 356,230.378739 356,163 C356,142.060479 361.275328,122.353077 370.569461,105.134315 C360.801674,107.658986 350.557442,109 340,109 C272.621261,109 218,54.3787395 218,-13 C218,-80.3787395 272.621261,-135 340,-135 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408\\u590D\\u5236",
    fill: "#FEE6FE",
    filter: "url(#filter-6)",
    mask: "url(#mask-4)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadHero);
export default __webpack_public_path__ + "static/media/download-hero.87f451bbb6771b9bfbb37fb57a74d320.svg";
export { ForwardRef as ReactComponent };